import React from "react";
import client from "@culturehq/client";
import { Form, ModalDialog, StringField, SubmitButton } from "@culturehq/components";

import { useDoor, useTryCatch } from "app/hooks";
import { Trans } from "app/utils";

import ErrorMessage from "components/common/ErrorMessage";
import ChqModalDialog from "components/common/ChqModalDialog";

const ProgramModal = ({ children, program, onCreate, onUpdate }) => {
  const { open, onOpen, onClose } = useDoor(false);

  const [{ error }, onSubmit] = useTryCatch(
    async ({ name }) => {
      if (program) {
        const response = await client.updateProgram({ programId: program.id, name });
        onUpdate(response.program);
      } else {
        const response = await client.createProgram({ name });
        onCreate(response.program);
      }

      onClose();
      window.location.reload();
    },
    [program, onClose, onCreate, onUpdate]
  );

  if (error && error.status !== 422) {
    throw error;
  }

  return (
    <>
      {children(onOpen)}
      {open && (
        <ChqModalDialog onClose={onClose}>
          <ModalDialog.Heading onClose={onClose}>
            {program ? <Trans>Edit Program</Trans> : <Trans>Add a Program</Trans>}
          </ModalDialog.Heading>
          <ModalDialog.Body>
            {error && <ErrorMessage error={error} />}
            <Form onSubmit={onSubmit} initialValues={program}>
              <StringField name="name" autoFocus required>
                <Trans>Program Name</Trans>
              </StringField>
              <SubmitButton primary>
                {submitting => (
                  submitting ? <Trans>Submitting...</Trans> : <Trans>Save</Trans>
                )}
              </SubmitButton>
            </Form>
          </ModalDialog.Body>
        </ChqModalDialog>
      )}
    </>
  );
};

export default ProgramModal;
